<template>
  <div class="box"  v-loading="loading">
    <breadcrumb :breadcrumb="breadcrumb"></breadcrumb>
    <div class="table_wrap">
      <div class="count">
        <div>
          {{ language("orderQuery.results") }}: {{ results }}
          {{ language("orderQuery.rows") }}
        </div>
        <div>
          <page :total="results" @pageChange="pageChange" ref="page"></page>
        </div>
      </div>

      <cc-table
        :loadData="false"
        :dataArr="dataArr"
        :config="table"
        :params="params"
        :refeshParams="refeshTable"
        :emptyText="language('orderQuery.emptyText')"
        :showIndex="false"
        :buttonsWidth="100"
      ></cc-table>
    </div>

    <el-dialog
      :close-on-click-modal="false"
      title="Details"
      :visible.sync="dialog"
      width="90%"
      append-to-body
    >
      <template v-if="dialog">
        <warehousing-product-list
          :oerderData="oerderData"
        ></warehousing-product-list>
      </template>
    </el-dialog>
  </div>
</template>
<script>
import breadcrumb from "../../components/breadcrumb";
import page from "../../components/page";
import warehousingProductList from "./components/warehousingProductList.vue";

export default {
  components: {
    breadcrumb,
    page,
    warehousingProductList,
  },
  data() {
    return {
      breadcrumb: {
        title: this.language("warehousingManagement.breadcrumbTitle"),
        list: [
          {
            name: this.language("warehousingManagement.breadcrumbList_1"),
          },
          {
            name: this.language("warehousingManagement.breadcrumbList_2"),
          },
        ],
      },
      loading:false,
      params: {
        mchShopNum: 0,
        pageNo: 1,
        pageSize: 10,
      },
      refeshTable: -1,
      table: {
        api: "admin/deliver/warehousing/record/query",
        showPager: false,
        indexFixed: "left",
        columns: [
          { prop: "mchShopNum", lable: "Merchant ID", minWidth: 100 },
          //   { prop: "mchShopName", lable: "Merchant Name", minWidth: "160" },
          {
            minWidth: 100,
            lable: "Operation",
            prop: "operation",
            type: "tag",
            options: {
              0: {
                tagType: "success",
                text: "Receive",
              },
              1: {
                tagType: "danger",
                text: "Return",
              },
            },
          },
          {
            minWidth: 100,
            lable: "Status",
            prop: "status",
            type: "tag",
            options: {
              0: {
                tagType: "info",
                text: "Confirming",
              },
              1: {
                tagType: "success",
                text: "Confirmed",
              },
              2: {
                tagType: "danger",
                text: "Canceled",
              },
            },
          },
          { prop: "title", lable: "Title", minWidth: "160" },
          { minWidth: 160, lable: "CreateTime", prop: "createTime" },
          { minWidth: 160, lable: "UpdateTime", prop: "updateTime" },
          { prop: "updateUserName", lable: "Operator", minWidth: "100" },
        ],
        buttons: [
          {
            name: "Details",
            click: (row, index) => {
              console.log("row", row);
              this.oerderData = row;
              this.dialog = true;
            },
          },
          {
            name: "confirm",
            click: (row, index) => {
              
              this.confirm(row.id);
            },
            check: (row) => {
              if (row.status == 0) {
                return true;
              } else {
                return false;
              }
            },
          },
        ],
      },
      oerderData: {},
      dialog: false,
      results: 0,
      dataArr: [],
    };
  },
  mounted() {
    this.params.mchShopNum = this.$shopData.shopNum;
    this.getData();
  },
  methods: {
    confirm(id) {
      this.loading = true
      this.ccRequest
        .do("admin/merchant/warehousing/record/confirm", { id: id })
        .then((res) => {
          this.$message.success("success!");
          this.refeshTable = new Date().getTime();
          this.getData()
        })
        .catch((err) => {
          this.loading = false;
          this.$message.error(err.response.data.message);
        });
      console.log("this.shop", this.$shopData);
    },
    pageChange(e) {
      this.params.pageSize = e.pageSize;
      this.params.pageNo = e.pageNo;
      this.getData();
    },
    getData() {
      this.ccRequest
        .do("admin/merchant/warehousing/record/query", this.params)
        .then((res) => {
          this.loading = false;
          this.dataArr = res.rows;
          this.results = res.total;
        })
        .catch((err) => {
          this.loading = false;
          this.$message.error(err.response.data.message);
        });
      console.log("this.shop", this.$shopData);
    },
  },
};
</script>
<style scoped lang="scss">
.box {
  height: 100%;
}
.card_wrap {
  background: #f7f7f7;
  padding: 20px;
  h5 {
    font-size: $title;
    margin: 10px 0 20px 0;
  }
  .card {
    display: flex;
    flex-wrap: wrap;
    // justify-content: space-between;
    .status {
      flex: 2;
    }
    .ymd {
      padding-right: 20px;
      padding-left: 20px;
      flex: 1;
    }
    .input {
      width: 200px;
      flex: 1;
    }
  }
}
.tips {
  margin-top: 10px;
  font-size: $sbuTitle;
}
.button_wrap {
  margin-top: 20px;
}
.table_wrap {
  margin-top: 50px;
  .count {
    font-size: $sbuTitle;
    margin-bottom: 20px;
    font-weight: 600;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
}
</style>